<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">个人信息</div>
          <div class="card-body">
            <Form ref="create" :model="formValidate" :label-width="100">
              <FormItem label="授权APPID">
                <Input v-model="formValidate.appid" disabled></Input>
              </FormItem>
              <Divider />

              <FormItem label="后台账号">
                <Input v-model="formValidate.username" placeholder="请输入后台账号"></Input>
              </FormItem>
              <FormItem label="新密码">
                <Input v-model="formValidate.password1" placeholder="请输入后台新密码"></Input>
              </FormItem>
              <FormItem label="确认新密码">
                <Input v-model="formValidate.password2" placeholder="请再次输入后台新密码"></Input>
              </FormItem>



              <FormItem>
                <Button type="primary" @click="edit()" :loading="loading">保存</Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    putAdmin,
    getAdmin,
  } from "@/api/admin";
  export default {
    data() {
      return {
        formValidate: {
          appid: "",
          username: "",
          password1: "",
          password2: "",
        },

        loading: false,
      };
    },
    created() {
      this._getData();
    },

    methods: {


      // 获取列表
      _getData() {
        getAdmin().then((res) => {
          this.formValidate = res.data[0];
        });
      },

      // 更新信息
      edit() {
        if (!this.formValidate.username || !this.formValidate.password1 || !this.formValidate.password2) {
          return this.$Message.warning({
            background: true,
            content: "后台账号不能为空",
          });
        }
        if (this.formValidate.password1 != this.formValidate.password2) {
          return this.$Message.warning({
            background: true,
            content: "两次密码输入不一致",
          });
        }
        this.loading = true;
        putAdmin({
          username: this.formValidate.username,
          password: this.formValidate.password1,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false;
        });
      },
    },
  };
</script>

<style lang="less" scoped>
</style>